import { ca } from '@cian/analytics';
import {
  ICreateCianAnalyticsPageViewObjectParams,
  createCianAnalyticsPageViewObject,
} from './createCianAnalyticsPageViewObject';

export const trackPageView = (params: ICreateCianAnalyticsPageViewObjectParams) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ca('pageviewSite', createCianAnalyticsPageViewObject(params) as any);
};
